import { graphql } from '../graphql';
import { useRequest } from './client/useRequest';
export const GET_EVENTS = graphql(`
  query GetEvents($timestamp: String!, $seenIds: [String!]) {
    getEvents(input: { timestamp: $timestamp, seenIds: $seenIds }) {
      id
      persistedTimestamp
      source
      type
      actionEvent {
        action
        remarks
      }
      supportCaseStatusEvent {
        by
        status
        reason
      }
      messageStatusEvent {
        status
        messageId
      }
      messagingStateEvent {
        from
        state
      }
      messageEvent {
        messageType
        from
        text {
          message
        }
        attachment {
          url
          caption
        }
        question {
          text
          options {
            value
            label
            description
            optionType
          }
        }
        command {
          text
          items {
            command
            label
          }
        }
        secureForm {
          invitationId
          url
          title
        }
      }
    }
  }
`);
export const useGetEventsRequest = () => {
    return useRequest(GET_EVENTS, {});
};
